/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Money
 */
export interface Money {
    /**
     * The monetary amount.
     * @type {number}
     * @memberof Money
     */
    amount: number;
    /**
     * The currency code.
     * @type {string}
     * @memberof Money
     */
    currency: string;
}

/**
 * Check if a given object implements the Money interface.
 */
export function instanceOfMoney(value: object): boolean {
    if (!('amount' in value)) return false;
    if (!('currency' in value)) return false;
    return true;
}

export function MoneyFromJSON(json: any): Money {
    return MoneyFromJSONTyped(json, false);
}

export function MoneyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Money {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'currency': json['currency'],
    };
}

export function MoneyToJSON(value?: Money | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'amount': value['amount'],
        'currency': value['currency'],
    };
}

